enum FactoryType {
  cell,
  unit,
}
export default FactoryType;
